<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Fisiologica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiFisiologica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiFisiologica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiFisiologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiFisiologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiFisiologica: "/rsaschedarelazionesanitariaanamnesifisiologica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiFisiologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiFisiologica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiFisiologicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFisiologicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiFisiologica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFisiologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiFisiologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSalvaAnamnesiFisiologica() {
            let me = this;
            me.jsonDataAnamnesiFisiologica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiFisiologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiFamiliare, me.jsonDataAnamnesiFamiliare, me.saveSchedaRelazioneSanitariaAnamnesiFisiologicaSuccessResponse, me.saveSchedaRelazioneSanitariaFisiologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiFisiologicaSuccessResponse() {},
        saveSchedaRelazioneSanitariaAnamnesiFisiologicaErrorResponse() {
            console.error("Errore nel salvataggio dell'anamnesi fisiologica:");
        },
    },
};
</script>
